import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Navigation, Loader } from 'common';
import { Grid } from '@material-ui/core';
import { default as EditJob } from 'components/job/edit/editContainer';
import TopBar from '../sections/topBar';
import './edit.scss';

class EditContainer extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
    };
  }

  onBackClick = () => {
    const { history } = this.props;

    history.goBack();
  };

  render() {
    const { loading } = this.state;
    const { history, match, location, jobRole, jobStatus } = this.props;

    if (loading) {
      return <Loader />;
    }

    return (
      <div className="edit-candidate-wrapper">
        <Navigation />
        <TopBar
          fromPage={'jobView'}
          jobRole={jobRole}
          jobStatus={jobStatus}
          onBackClick={this.onBackClick}
        />
        <Grid container spacing={0} justify="center" className="edit-candidate">
          <Grid item xs={12}>
            <EditJob history={history} match={match} location={location} />
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    jobRole: state.job.selectedJob.jobRole,
    jobStatus: state.job.selectedJob.jobStatus,
    jobId: state.job.selectedJob.jobId,
  };
};

export default connect(mapStateToProps, null)(EditContainer);
